// extracted by mini-css-extract-plugin
export default {"basicButton":"basic-button_basicButton__EeFGg","disabledTooltip":"basic-button_disabledTooltip__YR7af","shortcut":"basic-button_shortcut__sw619"};